export default __webpack_public_path__ + "static/media/088.40271bfc.jpg";